import React from 'react';

const DropboxIcon = ({ size = 24, className = '' }: { size?: number, className?: string }) => {
  return (
    <svg
      xmlns="http://www.2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      fill="#0061FE"
    >
      <path d="M12.01 2.22l-5.69 3.66L1.13 2.22 6.82-1.44l5.19 3.66zm0 7.32l-5.69-3.66-5.19 3.66 5.69 3.66 5.19-3.66zm5.69-7.32L12.01-1.44 6.82 2.22l5.19 3.66 5.69-3.66zM22.87 2.22l-5.19 3.66-5.69-3.66 5.19-3.66 5.69 3.66zm-5.69 3.66l5.19 3.66-5.69 3.66-5.19-3.66 5.69-3.66zM12.01 13.2l5.69-3.66-5.19-3.66-5.69 3.66 5.19 3.66zm-5.19 4.38l5.19 3.33 5.19-3.33v-2.22l-5.19 3.33-5.19-3.33v2.22z" transform="translate(0, 4)"/>
    </svg>
  );
};

export default DropboxIcon;
